<div class="flyout-wrapper" [class.active]="isOpen()">
  <div class="flyout-header">
    <button (click)="close()">x</button>
  </div>
  <div class="flyout-body">
    @if (contentComponent(); as component) {
      <ng-container *ngComponentOutlet="component" />
    }
  </div>
</div>
